function isVisible(el) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}

const gold_price_url = 'https://gold.personaly-meinekette-custom.de';

function formatNumberDE(num) {
  const n = Number(num);

  if (isNaN(n)) return num;
  let [integer, decimal] = n.toFixed(2).split('.');
  integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${integer},${decimal}`;
}

window.afterPriceLoad = (item, up) => {
  const goldPriceObj = window?.live_price?.gold
  const silverPriceObj = window?.live_price?.silver
  const goldPrice = goldPriceObj?.price_int
  const silverPrice = silverPriceObj?.price_int
  if(!window?.live_price){
    return
  }

  const priceEls = item ? [item] : document.querySelectorAll(`[data-live-price]`)
  priceEls.forEach((item) => {
      const weight = parseFloat(item.getAttribute('data-product-weight'));
      const modifier = parseFloat(item.getAttribute('data-product-kurs'));
      const multiplier = parseFloat(item.getAttribute('data-product-multiplier'));

      let priceType = item.getAttribute("data-metal")
      let priceFloat = goldPrice;
      if(priceType == "silver"){
        priceFloat = silverPrice;
      }
      
      if ([weight, priceFloat, modifier, multiplier].some(isNaN)) {
          console.warn('Invalid pricing data', { weight, priceFloat, modifier, multiplier });
      }else {
          let normalPrice = (weight) * ((priceFloat + modifier) * multiplier)
          const qty = $(item).closest(".quanitity-investment").find(`[name="quantity"]`).val() ?? 1;
          normalPrice *= qty

          const obj = {weight: weight, modifier: modifier, multiplier: multiplier, type: priceType || "gold"}
          let updateEl = item.querySelector(gold_price_selector)
          if($(item).hasClass("price-span")) {
            updateEl = item
          }
          $(updateEl).text(shopifyFormatCurrency(normalPrice * 100))
          const priceProperty = `<input class="live-price-prop" type="hidden" value="${normalPrice}" name="properties[_live_price]" />`
          const priceObjProperty = $(`<input class="live-price-prop" type="hidden" value="" name="properties[_live_price_obj]" />`)
          // priceObjProperty.val(JSON.stringify(obj))
          if($(item).closest(".product-title-container").length > 0){
            $(`.product-grid-container form[action="/cart/add"]`).each(function() {
              if(up) {
                $(this).find(`.live-price-prop`).remove();
              }
              if($(this).find(`.live-price-prop`).length > 0){
                return;
              }
              $(this).append(priceProperty)
              $(this).append(priceObjProperty)
            })
          }
          if($(item).closest("product-card").length > 0){
            $(item).closest("product-card").attr('data-price-now', normalPrice).attr('data-live-price-obj', JSON.stringify(obj))
          }
      }

      window.live_price_initilized = true
      $("body").addClass("live_price_initilized")
  })


  document.querySelectorAll('.live-gold-price').forEach(el => {
    el.textContent = `€${goldPriceObj?.price_now}`;
  });

  document.querySelectorAll('.gold-percentage-change').forEach(el => {
    const change = goldPriceObj?.percentage_change || 0;
    const text = (change < 0 ? "" : "+") + change + "%";

    el.textContent = text;
    el.classList.remove("increase", "decrease");

    if (change > 0) el.classList.add("increase");
    if (change < 0) el.classList.add("decrease");
  });

  document.querySelectorAll('.live-silver-price').forEach(el => {
    el.textContent = `€${silverPriceObj?.price_now}`;
  });

  document.querySelectorAll('.silver-percentage-change').forEach(el => {
    const change = silverPriceObj?.percentage_change || 0;
    const text = (change < 0 ? "" : "+") + change + "%";

    el.textContent = text;
    el.classList.remove("increase", "decrease");

    if (change > 0) el.classList.add("increase");
    if (change < 0) el.classList.add("decrease");
  });


  document.querySelectorAll(`[data-silver-bulk]`).forEach(item => {
    const gram = item.getAttribute("data-silver-bulk")
    item.textContent = `€${formatNumberDE((Number(silverPriceObj?.price_int) * Number(gram)))}`
  })

  document.querySelectorAll(`[data-gold-bulk]`).forEach(item => {
    const gram = item.getAttribute("data-gold-bulk")
    item.textContent = `€${formatNumberDE((Number(goldPriceObj?.price_int) * Number(gram)))}`
  })
}

async function connectPrice() {
  const livePriceEls = document.querySelectorAll('.live-gold-price');
  const liveSilverPriceEls = document.querySelectorAll('.live-silver-price');
  if (![...livePriceEls].some(isVisible) && ![...liveSilverPriceEls].some(isVisible)) return;

  try {
    // const res = await fetch(gold_price_url + "/api/live-price");
    // if (!res.ok) throw new Error("Network response was not ok");

    // const data = await res.json();

    // document.querySelectorAll('.live-gold-price').forEach(el => {
    //   el.textContent = `€${data?.gold?.price_now}`;
    // });

    // document.querySelectorAll('.gold-percentage-change').forEach(el => {
    //   const change = data?.gold?.percentage_change || 0;
    //   const text = (change < 0 ? "" : "+") + change;

    //   el.textContent = text;
    //   el.classList.remove("increase", "decrease");

    //   if (change > 0) el.classList.add("increase");
    //   if (change < 0) el.classList.add("decrease");
    // });

    // document.querySelectorAll('.live-silver-price').forEach(el => {
    //   el.textContent = `€${data?.silver?.price_now}`;
    // });

    // document.querySelectorAll('.silver-percentage-change').forEach(el => {
    //   const change = data?.silver?.percentage_change || 0;
    //   const text = (change < 0 ? "" : "+") + change;

    //   el.textContent = text;
    //   el.classList.remove("increase", "decrease");

    //   if (change > 0) el.classList.add("increase");
    //   if (change < 0) el.classList.add("decrease");
    // });


    // document.querySelectorAll(`[data-silver-bulk]`).forEach(item => {
    //   const gram = item.getAttribute("data-silver-bulk")
    //   item.textContent = `€${formatNumberDE((Number(data?.silver?.price_int) * Number(gram)))}`
    // })

    // document.querySelectorAll(`[data-gold-bulk]`).forEach(item => {
    //   const gram = item.getAttribute("data-gold-bulk")
    //   item.textContent = `€${formatNumberDE((Number(data?.gold?.price_int) * Number(gram)))}`
    // })

  } catch (err) {
    console.error("Price fetch failed:", err);
  }
}

connectPrice();




let currentRange = 'today';
let currentMetal = 'gold';
const charts = new Map();

function renderCharts(labels, data, metal, all) {
  const canvases = document.querySelectorAll('.data-live-chart');
  if (!canvases.length) return;

  canvases.forEach(canvas => {
    if (!isVisible(canvas)) return;


    if(canvas.getAttribute("data-type") == "silver") {
      metal = 'silver'
      data = all?.silver
    }
  
    const labelText = metal === "gold"
      ? "Gold (€ per gram)"
      : "Silver (€ per gram)";

    const borderColor = metal === "gold"
      ? "#FFD700"
      : "#C0C0C0";

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const isLabel = canvas.dataset.label !== '0';

    let aspectRatio = window.innerWidth < 700 ? (1) : 2;
    if (canvas.dataset.ratio) {
      const [w, h] = canvas.dataset.ratio.split('/').map(Number);
      if (w && h) aspectRatio = w / h;
    }

    // UPDATE
    if (charts.has(canvas)) {
      const chart = charts.get(canvas);
      chart.data.labels = labels;
      chart.data.datasets[0].label = labelText;
      chart.data.datasets[0].data = data;
      chart.data.datasets[0].borderColor = borderColor;
      chart.update();
      return;
    }

    let chartType = 'line'
    let fill = false;
    if(canvas.getAttribute("data-chart-type") == "bar"){
      chartType = 'bar'
      fill = true
    }

    function getGradient(ctx, chartArea) {
        let gradient;
        // Create the gradient only if it doesn't exist or the chart size has changed
        if (!gradient || width !== chartArea.right - chartArea.left || height !== chartArea.bottom - chartArea.top) {
            width = chartArea.right - chartArea.left;
            height = chartArea.bottom - chartArea.top;
    
            // Create a vertical gradient (x0, y0, x1, y1)
            gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
    
            // Add color stops
            gradient.addColorStop(0, '#FFFFFF'); // White at the bottom
            gradient.addColorStop(0.5, '#b6a33b'); // Yellow in the middle
            gradient.addColorStop(1, borderColor); // Red at the top
        }
        return gradient;
    }

    // CREATE
    const chart = new Chart(ctx, {
      type: chartType,
      data: {
        labels,
        datasets: [{
          label: labelText,
          data,
          borderColor,
          borderWidth: 1,
          backgroundColor: (context) => {
            const chart = context.chart;
            const { ctx, chartArea } = chart;
            if (!chartArea) return;
            return getGradient(ctx, chartArea);
          },
          fill: false,
          tension: isLabel ? 0.3 : 0,
          pointRadius: 0,
          pointHoverRadius: 0,
          pointBorderWidth: 0,
          pointHoverBorderWidth: 0,
          pointHitRadius: 0
        }]
      },
      options: {
        responsive: true,
        aspectRatio,

        interaction: isLabel ? {
          mode: 'index',
          intersect: false
        } : { mode: null },

        plugins: {
          legend: { display: false },
          tooltip: { enabled: isLabel }
        },

        elements: {
          point: {
            radius: 0,
            hoverRadius: 0,
            hitRadius: 0,
            borderWidth: 0,
            hoverBorderWidth: 0
          }
        },

        scales: {
          x: { display: isLabel },
          y: { display: isLabel }
        }
      }
    });

    charts.set(canvas, chart);
  });
}



async function connectChartSSE(range, metal = 'gold') {
  const response = await fetch(
    `${gold_price_url}/chart?live=1&range=${range}`
  );

  const data = await response.json();

  const labels = data.labels;
  const gold = data.gold.map(Number);
  const silver = data.silver.map(Number);

  renderCharts(labels, metal === 'gold' ? gold : silver, metal, {silver, gold});
}

connectChartSSE(currentRange);


document.body.addEventListener('click', e => {
  const btn = e.target.closest('.select-range-live');
  if (!btn) return;

  if (btn.classList.contains('active')) return;

  currentRange = btn.dataset.value;

  btn.classList.add('active');
  btn.parentElement
    ?.querySelectorAll('.select-range-live')
    .forEach(el => el !== btn && el.classList.remove('active'));

  connectChartSSE(currentRange, currentMetal);
});



async function updateCartLivePrice(cart) {

  const response = await fetch('/cart.json')
  let res = await response.json()
  const items = res?.items;

  let updates = []

  if(items && items?.length > 0){

    items?.forEach((item) => {
      if(item?.properties?._live_price){
        const obj = item?.properties?._live_price_obj
        let data_live_price_obj = null
        try {
          data_live_price_obj = JSON.parse(obj)
        } catch (error) {
          console.log(error);
        }
        if(data_live_price_obj?.weight){

        }
      }
    })

  }
  if(updates.length == 0) {
    return;
  }
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      updates: {
        "line_item_key_1": 2,
        "line_item_key_2": 1
      },
      properties: {
        "line_item_key_1": {
          custom_field: "value1",
          gold_price_locked: "true"
        },
        "line_item_key_2": {
          custom_field: "value2"
        }
      }
    })
  });
}


const gold_price_selector = ".main-price-item"
var last_price_update = false;
// const goldPriceApi = 'http://127.0.0.1:8000/api/live-price'
var generateGoldPrice = async (callback) => {
    const diffSeconds = (Date.now() - last_price_update) / 1000
    if (diffSeconds < 30 && last_price_update) {
      return;
    }
    last_price_update = Date.now()
    let response = await fetch(gold_price_url+"/api/live-price")
    response = await response.json()
    window.live_price = response;
    afterPriceLoad()
    callback?.()
    updateCartLivePrice()
}
generateGoldPrice()

document.addEventListener('live:price', (e) => {
  generateGoldPrice()
})

setInterval(() => {
  const diffSeconds = (Date.now() - last_price_update) / 1000
  if (diffSeconds >= 30) {
    generateGoldPrice()
  }
}, 1000)



function shopifyFormatCurrency(cents) {
    const placeholderRegex = /{{\s*(\w+)\s*}}/;
  
    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
        if (isNaN(number) || number == null) {
            return "0";
        }
    
        const numString = (number / 100.0).toFixed(precision);
        const parts = numString.split(".");
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
        const cents = parts[1] ? decimal + parts[1] : "";
        return dollars + cents;
    }
    
    const formatString = window.money_format
    if(!formatString){
        return cents / 100
    }

    return formatString.replace(placeholderRegex, (match, placeholder) => {
        switch (placeholder) {
            case "amount":
                return formatWithDelimiters(cents, 2);
            case "amount_no_decimals":
                return formatWithDelimiters(cents, 0);
            case "amount_with_comma_separator":
                return formatWithDelimiters(cents, 2, ".", ",");
            case "amount_no_decimals_with_comma_separator":
                return formatWithDelimiters(cents, 0, ".", ",");
            case "amount_with_apostrophe_separator":
                return formatWithDelimiters(cents, 2, "'", ".");
            case "amount_no_decimals_with_space_separator":
                return formatWithDelimiters(cents, 0, " ");
            case "amount_with_space_separator":
                return formatWithDelimiters(cents, 2, " ", ",");
            case "amount_with_period_and_space_separator":
                return formatWithDelimiters(cents, 2, " ", ".");
            default:
                return match;
        }
    });
}